module.exports = __webpack_public_path__ + "static/billsbot-eu-7df60f8241fa99d1bc4ade717553b7c4.svg";